import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

import {
	ItemDescriptionContainer,
	LinkStyle,
	Name,
} from './shopBagItemStyles';
import SubscriptionDetails from './SubscriptionDetails';

class ItemDescription extends PureComponent {
	static propTypes = {
		name: PropTypes.string.isRequired,
		href: PropTypes.string.isRequired,
		subscriptionTypeTerm: PropTypes.shape({
			id: PropTypes.number,
			name: PropTypes.string,
			numCycles: PropTypes.number,
		}),
		productInstance: PropTypes.shape({
			id: PropTypes.number,
			product: PropTypes.shape({
				id: PropTypes.number,
				billing: PropTypes.object,
				image: PropTypes.string,
				name: PropTypes.string,
				singlePurchasable: PropTypes.bool,
			}),
		}),
		price: PropTypes.number,
		currencySymbol: PropTypes.string,
		quantity: PropTypes.number,
	};

	static defaultProps = {
		price: 0,
		currencySymbol: "$",
		quantity: 0,
	};

	trimName = name => {
		const MAX_CHARS = 22; // Any more than 22 characters and the spacing of the delete button and price gets all wonky
		const nameLength = name.length;
		return nameLength <= MAX_CHARS
			? name
			: name.split('').splice(0, MAX_CHARS).join('') + '...'
		;
	};

	render() {
		return (
			<ItemDescriptionContainer>
				<LinkStyle href={this.props.href}>
					<Name>{this.trimName(this.props.name)}</Name>
				</LinkStyle>
				<SubscriptionDetails 
					productBilling={this.props.productInstance?.product?.billing}
					price={this.props.price}
					numCycles={this.props.subscriptionTypeTerm?.numCycles}
					currencySymbol={this.props.currencySymbol}
					quantity={this.props.quantity}
				/>
			</ItemDescriptionContainer>
		);
	}
}

export default ItemDescription;
